// extracted by mini-css-extract-plugin
module.exports = {"main":"PageContent_main__OH_VM","header":"PageContent_header__KfuBG"};